import type { AddressBookVariable } from '@common/types/address-book.type';
import type { FormElement } from '@common/types/form-element.type';
import type { FormElementFormGroup } from '@common/types/form-element-forms.type';
import type { CrmPipeline } from '@integrations/crm-pipelines';
import type { CrmDeal } from '@integrations/crm-deals';
import type { CrmContact } from '@integrations/crm-contacts';

import { environment } from '@web-env/environment';

import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { WebBaseControlTypedSettingsComponent } from '@web/widgets/common/abstract/web-base-control-typed-settings.component';
import { LayoutFacade } from '@web/store/layout/layout.facade';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { SpFormElementSettingsModule } from '@components/sp-form-element-settings/src/sp-form-element-settings.module';
import { WebSettingsModule } from '@web/shared/components/web-settings/web-settings.module';

@Component({
    selector: 'web-shop-cart-form-element-settings',
    templateUrl: './shop-cart-form-element-settings.component.html',
    styleUrls: ['./shop-cart-form-element-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [WebSettingsModule, SpFormElementSettingsModule, AsyncPipe, TranslateModule],
})
export class ShopCartFormElementSettingsComponent extends WebBaseControlTypedSettingsComponent<FormElementFormGroup> {
    @Input() public elements!: FormElement[];

    @Input() public addressBookVariablesList: AddressBookVariable[] = [];
    @Input() public crmPipelinesList: CrmPipeline[] = [];
    @Input() public crmContactsVariablesList: CrmContact[] = [];
    @Input() public crmDealsVariablesList: CrmDeal[] = [];

    @Input() public isMainField: boolean = false;
    @Input() public isAddressBookListDisabled: boolean = false;

    private readonly layoutFacade: LayoutFacade = inject(LayoutFacade);

    public readonly baseHref = environment.baseHref;
    public readonly selectedDeviceMode$ = this.layoutFacade.deviceMode$;
}
